const enroll = {
  path: 'enroll',
  component: resolve => require(['../../../../../pages/portal/sbs/training/enroll'], resolve)
}

export default enroll
